const printSelector = '.print-btn';

function printHandler(e){
    const printBtn = e.target.closest(printSelector);
    if (printBtn){
        print();
    }
}

export default printHandler;